module.exports = __webpack_public_path__ + "media/images/flags/4x3/cmr-eb4cbbfe2427017a7855cab735577afb.svg";